import { Col, Row } from 'react-bootstrap';
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectBeesById } from '../../ducks/bees';
import SmallSubjectCard from '../SmallSubjectCard';
import HorizontalScroll from '../HorizontalScroll';
import sortBeesByDutchName from '../../utils/sortBeesByDutchName';

const HorizontalBeeShowcase = ({ archInfo }) => {
  const {
    arch,
    coverage,
  } = archInfo;

  const beesById = useSelector(selectBeesById);

  if (!arch) {
    return null;
  }
  const beeIds = Object.keys(arch);

  const sortedBeeIds = sortBeesByDutchName(beeIds, beesById);

  return (
    <HorizontalScroll className="d-none d-lg-flex" as={Row}>
      {
        sortedBeeIds.map((beeId) => (
          <Col
            md={4}
            key={beesById[beeId].id}
          >
            <SmallSubjectCard
              foodCoverage={coverage.perBee[beeId]}
              imagePath={beesById[beeId].imagePath}
              name={beesById[beeId].dutchName}
            />
          </Col>
        ))
      }
    </HorizontalScroll>
  );
};

HorizontalBeeShowcase.propTypes = {
  archInfo: PropTypes.shape({
    arch: PropTypes.shape(),
    coverage: PropTypes.shape(),
    minMonth: PropTypes.string,
    maxMonth: PropTypes.string,
  }),
};

HorizontalBeeShowcase.defaultProps = {
  archInfo: null,
};

export default HorizontalBeeShowcase;
